<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-truck-fast" aria-hidden="true"></i></span>{{ 'AreaMappingRFQMaintenance.Header' | translate }}
  </h1>

  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [selected]="isSearchFormOpen"
      >

        <!-------------------------------------- Query Form ---------------------------------------------->
        <Form
          [formGroup]="searchFormGroup"
          (ngSubmit)="searchBtnClick()"
        >
          <div class="p-fluid formgrid grid">

            <!-------------------------------------- Country Slot ---------------------------------------------->
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label for="formCountry">{{ 'AreaMappingRFQMaintenance.Form.Country' | translate }}</label>
              <p-dropdown
                inputId="formCountry"
                placeholder="{{ 'AreaMappingRFQMaintenance.Placeholder.OptionHint.SelectACountry' | translate }}"
                (onChange)="formSelectedCountryChanged($event)"
                [filter]="true"
                [showClear]="true"
                [options]="countryOptions"
                [virtualScroll]="true"
                [itemSize]="40"
                formControlName="country"
              >
              </p-dropdown>
            </div>

            <!-------------------------------------- City Slot ---------------------------------------------->
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label for="formCity">{{ 'AreaMappingRFQMaintenance.Form.City' | translate }}</label>
              <p-multiSelect
                inputId="formCity"
                placeholder="{{ 'AreaMappingRFQMaintenance.Placeholder.OptionHint.SelectOneOrMoreCity' | translate }}"
                display="chip"
                [options]="formCityOptions"
                [virtualScroll]="true"
                [itemSize]="40"
                formControlName="citySeqNo"
              >
              </p-multiSelect>
            </div>

            <!-------------------------------------- Assignment District Slot ---------------------------------------------->
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label for="formAssignmentDistrict">{{ 'AreaMappingRFQMaintenance.Form.AssignmentDistrict' | translate }}</label>
              <p-multiSelect
                inputId="formAssignmentDistrict"
                placeholder="{{ 'AreaMappingRFQMaintenance.Placeholder.OptionHint.SelectOneOrMoreAssignmentDistrict' | translate }}"
                display="chip"
                [options]="formAssignmentDistrictOptions"
                [virtualScroll]="true"
                [itemSize]="40"
                formControlName="assignmentDistrictId"
              >
              </p-multiSelect>
            </div>

            <!-------------------------------------- RFQ Country Slot ---------------------------------------------->
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label for="formRFQCountry">{{ 'AreaMappingRFQMaintenance.Form.RFQCountry' | translate }}</label>
              <input pInputText
                id="formRFQCountry"
                type="text"
                maxlength="100"
                formControlName="rfqCountry"
              />
            </div>

            <!-------------------------------------- RFQ City Slot ---------------------------------------------->
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label for="formRFQCity">{{ 'AreaMappingRFQMaintenance.Form.RFQCity' | translate }}</label>
              <input pInputText
                id="formRFQCity"
                type="text"
                maxlength="100"
                formControlName="rfqCity"
              />
            </div>

            <!-------------------------------------- RFQ Area Code Slot ---------------------------------------------->
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label for="formRFQAreaCode">{{ 'AreaMappingRFQMaintenance.Form.RFQAreaCode' | translate }}</label>
              <input pInputText
                id="formRFQAreaCode"
                type="text"
                maxlength="100"
                formControlName="rfqAreaCode"
              />
            </div>

            <!-------------------------------------- RFQ Area Name Slot ---------------------------------------------->
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label for="formRFQAreaName">{{ 'AreaMappingRFQMaintenance.Form.RFQAreaName' | translate }}</label>
              <input pInputText
                id="formRFQAreaName"
                type="text"
                maxlength="100"
                formControlName="rfqAreaName"
              />
            </div>
          </div>

          <!-------------------------------------- Form Button ---------------------------------------------->
          <div>

            <!-------------------------------------- Query Button ---------------------------------------------->
            <button pButton
              type="submit"
              label="{{ 'Common.Button.Search' | translate }}"
            ></button>

            <!-------------------------------------- Reset Button ---------------------------------------------->
            <button pButton
              type="reset"
              label="{{ 'Common.Button.Reset' | translate }}"
              class="p-button-secondary ml-2"
            ></button>

          </div>
        </Form>
      </p-accordionTab>
    </p-accordion>

    <!-------------------------------------- Table ---------------------------------------------->
    <p-table #table
      [columns]="selectedTableColumns"
      [value]="tableData"
      [loading]="isLoading"
      [resizableColumns]="true"
      [reorderableColumns]="true"

      [scrollable]="true"
      scrollHeight="500px"
      scrollDirection="both"

      [(selection)]="selectedRow"
      selectionMode="single"

      [lazy]="true"
      (onPage)="onTablePageChanging($event)"
      (onSort)="onTableSorting($event)"
      [resetPageOnSort]="false"

      [paginator]="true"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate }}"
      [rows]="pageInfo.pageSize"
      [rowsPerPageOptions]="[5, 10, 20]"
      [totalRecords]="pageInfo.totalRecords"

      dataKey="dataKey"
      editMode="row"
      class="datatable"
      styleClass="p-datatable-gridlines p-datatable-stripped mt-2 white-space: nowrap;"
    >
      <!-------------------------------------- Table Caption Part ---------------------------------------------->
      <ng-template pTemplate="caption">

        <!-------------------------------------- Display Column List ---------------------------------------------->
        <laas-table-column-toggle
          [optionsColumn]="tableColumns"
          [dataTable]="table">
        </laas-table-column-toggle>

        <!-------------------------------------- Add Button ---------------------------------------------->
        <button pButton
          class="p-button-success p-button-raised ml-2"
          label="{{ 'Common.Button.Add' | translate }}"
          icon="fa fa-plus"
          [disabled]="!isInEditMode"
          (click)="addNewRow()"
        ></button>

        <!-------------------------------------- Delete Button ---------------------------------------------->
        <button pButton
          class="p-button-danger p-button-raised ml-2"
          label="{{ 'Common.Button.Delete' | translate }}"
          icon="fas fa-trash-alt"
          [disabled]="!isInEditMode || tableData.length <= 0"
          (click)="deleteSelectedRow()"
        ></button>

        <!-------------------------------------- Save Button ---------------------------------------------->
        <button pButton
          class="p-button-raised ml-2"
          label="{{ 'Common.Button.Save' | translate }}"
          icon="fas fa-save"
          [disabled]="!isInEditMode"
          (click)="saveChanges()"
        ></button>

        <!-------------------------------------- Restore Button ---------------------------------------------->
        <button pButton
          class="p-button-secondary p-button-raised ml-2"
          label="{{ 'AreaMappingRFQMaintenance.Table.Button.Restore' | translate }}"
          icon="fas fa-sync-alt"
          [disabled]="!isInEditMode"
          (click)="restoreTableDate()"
        ></button>

        <!-------------------------------------- Edit Button ---------------------------------------------->
        <button pButton
          style="color: white"
          class="p-button-warning p-button-raised ml-2"
          label="{{ isInEditMode ? ( 'Common.Button.Cancel' | translate ) : ( 'Common.Button.Edit' | translate ) }}"
          icon="fas fa-pen"
          (click)="switchEditMode()"
        ></button>
      </ng-template>

      <!-------------------------------------- Table Column Group Part ---------------------------------------------->
      <!---------------------------- Make columns as a group for horizontal scroll ---------------------------------------------->
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" style="width: 15vw">
        </colgroup>
      </ng-template>

      <!-------------------------------------- Table Header Part ---------------------------------------------->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" pReorderableColumn pResizableColumn
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            scope="col">
            {{ col.header | translate }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <!------------------------------------------- Table Body Part -------------------------------------------->
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="onRowSelect(rowData)">
          <ng-container [ngSwitch]="col.field" *ngFor="let col of columns">

            <!-------------------------------------- SeqNo Column ---------------------------------------------->
            <td *ngSwitchCase="'seqNo'">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: '-' }}
              </div>
            </td>

            <!-------------------------------------- Facility Column ---------------------------------------------->
            <td *ngSwitchCase="'facility'">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: "-" }}
              </div>
            </td>

            <!-------------------------------------- Country Column ---------------------------------------------->
            <td *ngSwitchCase="'country'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <p-dropdown
                    appendTo="body"
                    inputId="tableCountry"
                    placeholder="{{ 'AreaMappingRFQMaintenance.Placeholder.OptionHint.SelectACountry' | translate}}"
                    (onChange)="tableSelectedCountryChanged($event, rowData)"
                    [showClear]="true"
                    [filter]="true"
                    [options]="countryOptions"
                    [virtualScroll]="true"
                    [itemSize]="40"
                    [(ngModel)]="rowData[col.field]"
                  >
                  </p-dropdown>
                  <small *ngIf="!rowData[col.field]" class="p-invalid">
                    {{ 'AreaMappingRFQMaintenance.Message.FieldRequired' | translate }}
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- City Column ---------------------------------------------->
            <td *ngSwitchCase="'city'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <p-dropdown
                    appendTo="body"
                    inputId="tableCity"
                    placeholder="{{ 'AreaMappingRFQMaintenance.Placeholder.OptionHint.SelectACity' | translate}}"
                    [showClear]="true"
                    [filter]="true"
                    [options]="tableCityOptions"
                    [virtualScroll]="true"
                    [itemSize]="40"
                    [(ngModel)]="rowData[col.field]"
                  >
                  </p-dropdown>
                  <small *ngIf="!rowData[col.field]" class="p-invalid">
                    {{ 'AreaMappingRFQMaintenance.Message.FieldRequired' | translate }}
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping: this.allCityOptions | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Assignment District Id Column ---------------------------------------------->
            <td *ngSwitchCase="'assignmentDistrictId'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <p-dropdown
                    appendTo="body"
                    inputId="tableAssignmentDistrictId"
                    placeholder="{{ '
                    .Placeholder.OptionHint.SelectAAssignmentDistrict' | translate}}"
                    [showClear]="true"
                    [filter]="true"
                    [options]="tableAssignmentDistrictOptions"
                    [virtualScroll]="true"
                    [itemSize]="40"
                    [(ngModel)]="rowData[col.field]"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping: this.allAssignmentDistrictOptions  | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- RFQ Country Column ---------------------------------------------->
            <td *ngSwitchCase="'rfqCountry'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <input pInputText
                    id="tableRFQAreaCode"
                    type="text"
                    maxlength="100"
                    [(ngModel)]="rowData[col.field]"
                  />
                  <br>
                  <small *ngIf="!rowData[col.field]" class="p-invalid">
                    {{ 'AreaMappingRFQMaintenance.Message.FieldRequired' | translate }}
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- RFQ City Column ---------------------------------------------->
            <td *ngSwitchCase="'rfqCity'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <label for="tableRFQCity"></label>
                  <input pInputText
                    id="tableRFQCity"
                    type="text"
                    maxlength="100"
                    [(ngModel)]="rowData[col.field]"
                  /><br>
                  <small *ngIf="!rowData[col.field]" class="p-invalid">
                    {{ 'AreaMappingRFQMaintenance.Message.FieldRequired' | translate }}
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- RFQ Area Code Column ---------------------------------------------->
            <td *ngSwitchCase="'rfqAreaCode'">
              <p-cellEditor class="p-fluid">
                <label for="tableRFQAreaCode"></label>
                <ng-template pTemplate="input">
                  <input pInputText
                    id="tableRFQAreaCode"
                    type="text"
                    maxlength="100"
                    [(ngModel)]="rowData[col.field]"
                  /><br>
                  <small *ngIf="!rowData[col.field]" class="p-invalid">
                    {{ 'AreaMappingRFQMaintenance.Message.FieldRequired' | translate }}
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- RFQ Area Name Column ---------------------------------------------->
            <td *ngSwitchCase="'rfqAreaName'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <label for="tableRFQAreaName"></label>
                  <input pInputText
                    id="tableRFQAreaName"
                    type="text"
                    maxlength="100"
                    [(ngModel)]="rowData[col.field]"
                  /><br>
                  <small *ngIf="!rowData[col.field]" class="p-invalid">
                    {{ 'AreaMappingRFQMaintenance.Message.FieldRequired' | translate }}
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- City SeqNo Column ---------------------------------------------->
            <td *ngSwitchCase="'citySeqNo'">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: "-" }}
              </div>
            </td>

            <!-------------------------------------- Create User Column ---------------------------------------------->
            <td *ngSwitchCase="'createUser'">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: '-' }}
              </div>
            </td>

            <!-------------------------------------- CreateDt Column ---------------------------------------------->
            <td *ngSwitchCase="'createDt'">
              <div class="overflow-text">
                {{ rowData[col.field] | date: 'YYYY-MM-dd HH:mm:ss' | replaceNullWith: '-' }}
              </div>
            </td>

            <!-------------------------------------- Update User Column ---------------------------------------------->
            <td *ngSwitchCase="'updateUser'">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: '-' }}
              </div>
            </td>

             <!-------------------------------------- UpdateDt Column ---------------------------------------------->
             <td *ngSwitchCase="'updateDt'">
              <div class="overflow-text">
                {{ rowData[col.field] | date: 'YYYY-MM-dd HH:mm:ss' | replaceNullWith: '-' }}
              </div>
            </td>
          </ng-container>
        </tr>
      </ng-template>

      <!-------------------------------------- Table Empty Message Part ---------------------------------------------->
      <!-------------------------------------- Message for empty table ---------------------------------------------->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            {{ "Common.Table.NoData" | translate }}
          </td>
        </tr>
      </ng-template>

    </p-table>
  </p-card>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
